module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/javascript-c90ed54c345f4ceadc6ec28bf046dda8.svg";